function ga_newsletter() {
    if(typeof gtag !== "function"){
        console.warn('Could not send newsletter event as gtag is not a function');
        return;
    }
    /* global gtag */
    gtag('config', 'UA-36099469-3', {
        'page_title': 'Bekræftet nyhedsbrevs tilmelding',
        'page_path': '/tilmeldings-nyhedsbrev-tak'
    });
}

function ga_signup_step(step) {
    if(typeof gtag !== "function"){
        console.warn('Could not send signup event as gtag is not a function');
        return;
    }

    let steps = {
        start: {
            title: main_translations.start,
            slug: main_translations.start_slug
        },
        modules: {
            title: main_translations.modules,
            slug: main_translations.modules_slug
        },
        participants: {
            title: main_translations.participants,
            slug: main_translations.participants_slug
        },
        payment: {
            title: main_translations.payment_address,
            slug: main_translations.payment_address_slug
        },
        confirm: {
            title: main_translations.approval,
            slug: main_translations.approval_slug
        },
        final: {
            title: main_translations.confirmation,
            slug: main_translations.confirmation_slug
        },
    };

    if(typeof step === "undefined"){
        console.error('No step supplied');
        return;
    }

    if( ! (step in steps) ){
        console.error('Invalid step',step,steps);
        return;
    }

    /* global gtag */
    gtag('config', 'UA-36099469-3', {
        'page_title' : steps[step].title,
        'page_path': '/tilmeldings-'+steps[step].slug
    });
}

function product_view(product){
    if(!isGtagDefined()){
        return false;
    }

    gtag('event', 'view_item', {
        "items": [
            product,
        ]
    });
}

function signupStart(product){
    if(!isGtagDefined()){
        return false;
    }

    gtag('event', 'add_to_cart', {
        "items": [product]
    });

    return window.dataLayer.push({
        ecommerce: {
            checkout:
                {
                    products: [product],
                    actionField: {step: 2}
                }
        },
        event: 'productAddToCart'
    });
}

function signupModules(product){
    if(!isGtagDefined()){
        return false;
    }

    window.dataLayer.push({
        ecommerce: {
            checkout:
                {
                    products: [product],
                    actionField: {step: 3}
                }
        },
        event: 'modulesAdded'
    });
}

function signupParticipants(product){
    if(!isGtagDefined()){
        return false;
    }

    window.dataLayer.push({
        ecommerce: {
            checkout:
                {
                    products: [product],
                    actionField: {step: 4}
                }
        },
        event: 'participantsAdded'
    });
}

function signupBillingInfo(product){
    if(!isGtagDefined()){
        return false;
    }

    window.dataLayer.push({
        ecommerce: {
            checkout:
                {
                    products: [product],
                    actionField: {step: 5}
                }
        },
        event: 'billingInfoAdded'
    });
}

function add_to_cart(product){
    if(!isGtagDefined()){
        return false;
    }

    gtag('event', 'add_to_cart', {
        "items": [
            product
        ]
    });
}

function ga_read_more(){
    if(!isGtagDefined()){
        return false;
    }

    gtag('event', 'laes_mere', {});
}

function isGtagDefined(){
    return typeof gtag === 'function';
}

module.exports = {
    ga_newsletter,
    ga_signup_step,
    product_view,
    add_to_cart,
    signupStart,
    signupModules,
    signupParticipants,
    signupBillingInfo,
    ga_read_more
};